/**
 * Moduł obsługujący nowe główne menu strukturalnie współdzielone z headless
 * @type {module}
 */
app.service('headlessMenu',function(html, lazyLoad) {
	let isInit = false, isMenuOpen = false, isAccountArea = false;
	let $self, $navToggle, $navToggleSticky, $menuCategories, $items, $uspItems, $accountAreaMenuToggle, $accountAreaMenu;

	let headlessMenuDebounceTimer;
	const DEBOUNCE_DELAY = 100; // ms

	// cache elementow DOM
	function setElements() {
		$self = $('#headless-main-menu');
		$navToggle = $('#nav-toggle');
		$navToggleSticky = $('#nav-toggle-sticky');
		$menuCategories = $('#categories-main-menu');
		$items = $menuCategories.find('.nav-main-category-list-item');
		$itemsContents = $menuCategories.find('.nav-category');
		$uspItems = $('#usp-menu li', $self);
		$accountAreaMenuToggle = $('#account-area-toggle > a', $self);
		isAccountArea = $accountAreaMenuToggle.length ? true : false;
		$accountAreaMenu = $('#account-area-menu', $self);
	}

	function activateCategoryContent(menuItem) {
		const $menuItem = $(menuItem).closest('.nav-main-category-list-item');
		if ($menuItem.hasClass('active')) {
			return;
		}
		html.add('menu-open');
		resetItems();
		$menuItem.addClass('active').find('.nav-main-category-list-item-focus').attr('aria-expanded', 'true');
		lazyLoad.check();
	}

	function resetItems() {
		$items.removeClass('active').find('.nav-main-category-list-item-focus').attr('aria-expanded', 'false');
	}

	function openMainMenu() {
		if (isMenuOpen) {
			return;
		}
		if (isAccountArea) {
			closeAccountAreaMenu();
		}
		$navToggle.addClass('active').attr('aria-expanded', 'true');
		$navToggleSticky.addClass('active').attr('aria-expanded', 'true');
		$menuCategories.addClass('active');
		isMenuOpen = true;
		html.remove('menu-close-button menu-close-cursor-above');
		html.add('menu-open');
	}
	function closeMainMenu(outsideClick = false) {
		$navToggle.removeClass('active').attr('aria-expanded', 'false');
		$navToggleSticky.removeClass('active').attr('aria-expanded', 'false');
		$menuCategories.removeClass('active');
		resetItems();
		isMenuOpen = false;
		!outsideClick ? html.add('menu-close-button') : html.add('menu-close-cursor-above');
		html.remove('menu-open');
	}

	function openAccountAreaMenu() {
		if(isMenuOpen) {
			closeMainMenu();
			isMenuOpen = false;
		}
		$accountAreaMenuToggle.addClass('active').attr('aria-expanded', 'true');
		$accountAreaMenu.addClass('active');
		html.add('menu-open');
	}
	function closeAccountAreaMenu() {
		$accountAreaMenuToggle.removeClass('active').attr('aria-expanded', 'false');
		$accountAreaMenu.removeClass('active');
		html.remove('menu-open');
	}

	function mainNavToggleButtonClick(e) {
		// obsługa kliknięcia przycisku menu głównego zwykłego i sticky
		e.preventDefault();
		e.stopPropagation();
		isMenuOpen ? closeMainMenu() : openMainMenu();
	}
	function mainNavToggleButtonKey(e) {
		// obsługa przycisku menu głównego zwykłego i sticky z klawiatury
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			e.stopPropagation();
			if (e.key === ' ') {
				$(e.target).trigger('click');
			}
		}
	}

	function openCategoryContent(menuItem) {
		resetItems();
		activateCategoryContent(menuItem);
	}
	function closeCategoryContent() {
		resetItems();
	}
	function keyboardCategoryNavigation(e) {
		// podstawowa obsługa menu klawiaturą
		const thisListItem = $(e.target).closest('.nav-main-category-list-item').eq(0);
		switch (e.key) {
			case 'Enter':
			case ' ':
			case 'ArrowRight':
				openCategoryContent(thisListItem);
				break;
			case 'ArrowUp':
				if ($(thisListItem).prev().length) {
					$(thisListItem).prev().find('.nav-main-category-list-item-focus').focus();
				}else {
					$items.last().find('.nav-main-category-list-item-focus').focus();
				}
				break;
			case 'ArrowDown':
				if ($(thisListItem).next().length) {
					$(thisListItem).next().find('.nav-main-category-list-item-focus').focus();
				} else {
					$items.first().find('.nav-main-category-list-item-focus').focus();
				}
				break;
			default:
				break;
		}
	}
	function focusNavToggleButton() {
		html.has('sticky') ? $navToggleSticky.focus() : $navToggle.focus();
	}
	function focusOnMenuItemForClosedCategory() {
		const element = $items.filter('.active').find('.nav-main-category-list-item-focus').eq(0);
		closeCategoryContent();
		$(element).focus();
	}

	function setEvents(){
		$navToggle.on('click', function(e) {
			mainNavToggleButtonClick(e)
		}).on('keyup', function(e) {
			mainNavToggleButtonKey(e);
		});
		$navToggleSticky.on('click', function(e) {
			mainNavToggleButtonClick(e)
		}).on('keyup', function(e) {
			mainNavToggleButtonKey(e);
		});

		if (isAccountArea) {
			$accountAreaMenuToggle.on('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				$accountAreaMenu.hasClass('active') ? closeAccountAreaMenu() : openAccountAreaMenu();
			}).on('keydown', function(e) {
				if (e.key === ' ') {
					e.preventDefault();
					e.stopPropagation();
					if (e.key === ' ') {
						$(e.target).trigger('click');
					}
				}
			});
		}
		// obsługa dla elementów listy głównego menu kategorii
		$items.on('mouseenter', function(){
			clearTimeout(headlessMenuDebounceTimer);
			const menuItem = this;
			headlessMenuDebounceTimer = setTimeout(function() {
				openCategoryContent(menuItem);
			}, DEBOUNCE_DELAY);
		}).on('mouseleave', function(e) {
			clearTimeout(headlessMenuDebounceTimer);
			headlessMenuDebounceTimer = setTimeout(function() {
				closeCategoryContent();
			}, DEBOUNCE_DELAY);
		}).on('click', '.nav-main-category-list-item-focus > a', function(e) {
			e.preventDefault(); // do odblokowania w ramach zmian w EUROTMGO-972
		}).on('keyup', '.nav-main-category-list-item-focus', function(e) {
			e.preventDefault();
			keyboardCategoryNavigation(e);
		});

		$('body').on('click', function(e){
			if (isMenuOpen) {  // kliknięcie poza menu głównym
				if (!$(e.target).closest($menuCategories).length && !$(e.target).closest($navToggle).length && !$(e.target).closest($navToggleSticky).length) {
					closeMainMenu(true);
				}
			}
			if (isAccountArea && $accountAreaMenu.hasClass('active')) {  // kliknięcie poza menu strefy klienta
				if (!$(e.target).closest($accountAreaMenu).length && !$(e.target).closest($accountAreaMenuToggle).length) {
					closeAccountAreaMenu();
				}
			}
		}).on('keyup', function(e) {
			if (e.key === 'Escape') {
				if (isMenuOpen) { // obsługa klawisza Escape dla menu głównego
					if ($items.filter('.active').length) { // jeśli jest aktywna kategoria, to focus na pierwszym elemencie tej kategorii
						focusOnMenuItemForClosedCategory();
					} else { // jeśli nie ma aktywnej kategorii, to zamknięcie menu głównego i focus na przycisku menu
						closeMainMenu();
						focusNavToggleButton();
					}
				}
				if (isAccountArea && $accountAreaMenu.hasClass('active')) { // obsługa klawisza Escape dla menu strefy klienta
					closeAccountAreaMenu();
					if (!html.has('sticky')) { // focus na przycisku strefy klienta
						$accountAreaMenuToggle.focus();
					}
				}
			}
			if (e.key === 'ArrowLeft' && $items.filter('.active').length) { // obsługa klawisza strzałki w lewo jako powrót do głównej listy menu kategorii
				focusOnMenuItemForClosedCategory();
			}
		}).on('focusin', function(e) { // obsługa zamykania aktywnego menu po wyjściu tabulatorem z jego obszaru
			if (isMenuOpen) { // zamknięcie dla menu głównego 
				if (!$(e.target).closest($menuCategories).length && !$(e.target).closest($navToggle).length && !$(e.target).closest($navToggleSticky).length) {
					closeMainMenu(true);
				}
			}
			if (isAccountArea && $accountAreaMenu.hasClass('active')) { // zamknięcie menu strefa klienta
				if (!$(e.target).closest($accountAreaMenu).length && !$(e.target).closest($accountAreaMenuToggle).length) {
					closeAccountAreaMenu();
				}
			}
		});

	}

	function init() {
		if(!isInit){
			setElements();
			if($self.length){
				setEvents();
			}
		}
		isInit=false;
	}
	return {
		init
	};
});
